export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/point.js
// module id = 16
// module chunks = 0